export var filterAndSortVariants = function(restrictions, variants) {
    if (restrictions) {
        variants = variants.filter(function(variant) {
            return meetsRestrictions(variant, restrictions, /* maxHwRes= */ {
                width: Infinity,
                height: Infinity
            });
        });
    }
    return variants.sort(function(v1, v2) {
        return v1.bandwidth - v2.bandwidth;
    });
};
var meetsRestrictions = function(variant, restrictions, maxHwRes) {
    var inRange = function(x, min, max) {
        return x >= min && x <= max;
    };
    var video = variant.video;
    // |video.width| and |video.height| can be undefined, which breaks
    // the math, so make sure they are there first.
    if (video && video.width && video.height) {
        if (!inRange(video.width, restrictions.minWidth, Math.min(restrictions.maxWidth, maxHwRes.width))) {
            return false;
        }
        if (!inRange(video.height, restrictions.minHeight, Math.min(restrictions.maxHeight, maxHwRes.height))) {
            return false;
        }
        if (!inRange(video.width * video.height, restrictions.minPixels, restrictions.maxPixels)) {
            return false;
        }
    }
    // |variant.frameRate| can be undefined, which breaks
    // the math, so make sure they are there first.
    if (variant && variant.video && variant.video.frameRate) {
        if (!inRange(variant.video.frameRate, restrictions.minFrameRate, restrictions.maxFrameRate)) {
            return false;
        }
    }
    if (!inRange(variant.bandwidth, restrictions.minBandwidth, restrictions.maxBandwidth)) {
        return false;
    }
    return true;
};

//# sourceMappingURL=utils.js.map